import script from "./RedirecionamentoView.vue?vue&type=script&setup=true&lang=js"
export * from "./RedirecionamentoView.vue?vue&type=script&setup=true&lang=js"

import "./RedirecionamentoView.vue?vue&type=style&index=0&id=c7d19b8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7d19b8e"]])

export default __exports__